import { MutationTree } from 'vuex';
import { CompanyProfileState } from './CompanyProfileTypes';
import { DocumentReference } from '@firebase/firestore-types';

export const mutations: MutationTree<CompanyProfileState> = {
  setCurrentCompanyProfileRef: (state: CompanyProfileState, payload: DocumentReference) => {
    state.currentCompanyProfileRef = payload;
  },
};
